import { createSelector } from "reselect";

import syncRepresentationOfCustomFieldsFromStatusState from "./syncRepresentationOfCustomFieldsFromStatusState";
import syncRepresentationOfEntityFoldersFromStatusState from "./syncRepresentationOfEntityFoldersFromStatusState";
import syncRepresentationOfNarrativeFromState from "./syncRepresentationOfNarrativeFromState";
import syncRepresentationOfTimeline from "./syncRepresentationOfTimeline";

const syncRepresentationOfTimelineFromStatusState = createSelector(
  // inputs
  syncRepresentationOfNarrativeFromState,
  syncRepresentationOfEntityFoldersFromStatusState,
  syncRepresentationOfCustomFieldsFromStatusState,

  // calculate based on inputs
  syncRepresentationOfTimeline
);

export default syncRepresentationOfTimelineFromStatusState;
